module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAJ1BMVEUAAAAeHh4XFxcZGRkaGhoaGhoYGBgaGhoZGRkZGRkZGRkZGRkZGRl7+L/YAAAADHRSTlMAESIzRHeIqrvM3e6hc831AAAAXklEQVQoz2OYcwYDnGQ46oIBYhiOMGAAn+EhaIhFkOWUAxbBGUexCDZET8YiyDQnAFOQgfWkAaYgg+VRLIIMOQVECmLTjs0irE7C5nis3sQWIFiDbhilEKwZAVuWAQD7vmVd5w3FLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/page_right_arrow.png
// module id = 256
// module chunks = 0